import React, { useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { NavLink, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import isEmpty from "is-empty";
import { login, setCurrentUser } from '../actions/users'
import { toastAlert } from "../lib/toastAlert";
import logoss from "../assets/images/logo.png";

const initialFormValue = {
    email: "",
    password: "",
};

const Login = () => {
    const [oldPw, setOldPw] = useState(false)
    const [formValue, setFormValue] = useState({ initialFormValue });
    const [errors, setErrors] = useState('')
    const navigate = useNavigate();
    const dispatch = useDispatch()

    const handleChange = (e) => {
        setErrors({})
        e.preventDefault();
        const { name, value } = e.target;
        let error = { ...errors, ...{ [name]: "" } };
        setErrors(error);
        let formData = { ...formValue, ...{ [name]: value } };
        setFormValue(formData);
    };
    const validation = () => {
        let errors = {};
        var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,6}))$/;

        if (isEmpty(formValue?.email)) {
            errors.email = "Email field is required";
        }
        else if (!(emailRegex.test(formValue?.email))) {
            errors.email = "Invalid email"
        }
        if (isEmpty(formValue?.password)) {
            errors.password = "Password field is required";
        }

        return errors
    }

    const handlelogin = async () => {

        try {
            var value = validation()
            if (!isEmpty(value)) {
                setErrors(value)
            }
            else {
                let {  error, result } = await login(formValue);
                if (isEmpty(error)) {
                    setErrors({})
                    await dispatch(setCurrentUser(result)) 
                    navigate('/dashboard')
                }
                else {
                    if (error) {
                        setErrors(error);
                        console.error(error)
                    } 
                }

            }
        } catch (err) {
            console.log("handlelogin err", err);
        }

    }

    return (
        <>
            <Container fluid className='common_bg position-relative p-0 login__wholeAligner d-flex align-items-center'>
                <div className='w-100'>
                    <Row className='justify-content-center'>
                        <Col lg={5} md={7} sm={10} xs={11}>
                            <div className='login__formHolder rounded-3 p-4'>
                                <div className='text-center mb-4'>
                                    <img src={logoss} className='log_logo img-fluid'/>
                                </div>
                                <div className='rp_singleinput_holder mb-4'>
                                    <p className='rp_label mb-2'>Email Address</p>
                                    <div className='rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2'>
                                        <input type='text' placeholder='Enter email' id="email" name="email" className='rp_singleInput flex-grow-1'
                                            onChange={(e) => { handleChange(e) }}
                                        />
                                    </div>
                                    <span className="text-danger f-12 d-block text-start mt-2">{errors?.email}</span>

                                </div>

                                <div className='rp_singleinput_holder mb-4'>
                                    <p className='rp_label mb-2'>Password</p>
                                    <div className='rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2'>
                                        <input type={oldPw ? 'text' : 'password'} placeholder='Enter Password' className='rp_singleInput flex-grow-1'
                                            name="password" id="password" onChange={(e) => { handleChange(e) }}
                                        />

                                        <i class={oldPw ? 'fa-solid fa-eye-slash' : "fa-solid fa-eye"} onClick={() => setOldPw(!oldPw)} />
                                    </div>
                                    <span className="text-danger f-12 d-block text-start mt-2">{errors?.password}</span>

                                </div>

                                <div className='text-center'>
                                    <button className='btn addcate mb-2 mt-2' onClick={() => { handlelogin() }}>Login</button>
                                </div>

                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </>
    )
}

export default Login